module.exports = __webpack_public_path__ + "media/src/public/img/main-bg-9c9443b4c8b4b362ac98731be9f55e49.webp";